export default import.meta.ROLLDOWN_FILE_URL_54SqGxWcyxX4t2USzGY1ag